import { Typography, InputLabel } from "@mui/material";
import { tss } from "tss-react";
import WizardPanel from "components/WizardPanel";
import { useAsyncEffect } from "services/AsyncService";

const steps = ["Details"];

const useStyles = tss.create({
    root: {
        position: "relative",
        top: 10,
    },
    title: {
        height: 16,
        color: "#434343",
        fontSize: 14,
        fontWeight: "bold",
        letterSpacing: "0.1px",
        paddingBottom: 60,
        paddingLeft: 12,
    },
    row: {
        position: "relative",
        top: 6,
        width: 371,
        height: 75,
        padding: "7px 12px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    label: {
        height: 14,
        color: "rgba(0,0,0,0.55)",
        fontSize: 12,
        letterSpacing: "0.4px",
    },
});

var globalValues: any = [];

function today() {
    let d = new Date();
    let currDate = d.getDate();
    let currMonth = d.getMonth() + 1;
    let currYear = d.getFullYear();
    return (
        currYear +
        "-" +
        (currMonth < 10 ? "0" + currMonth : currMonth) +
        "-" +
        (currDate < 10 ? "0" + currDate : currDate)
    );
}

function now() {
    var d = new Date(),
        h: string = d.getHours() + "",
        m: string = d.getMinutes() + "";
    if (parseInt(h) < 10) h = "0" + h;
    if (parseInt(m) < 10) m = "0" + m;
    return h + ":" + m;
}

type IProps = {
    activeStep: number;
    setValues: (values: any) => void;
};

function Details(props: IProps) {
    const { classes } = useStyles();
    const { activeStep } = props;
    const selectedType = `com.voxelfarm.program.view.blockmodel`;
    //console.log("DataTypes:", DataTypes);

    const initialState = globalValues[activeStep] || {
        dataType: selectedType,
        name: "New Block Model",
        date: today(),
        time: now(),
        csvHeader: "input",
    };

    useAsyncEffect(
        () => {
            return new Promise((resolve: any, reject: any) => resolve(initialState));
        },
        (results: any) => {
            props.setValues(initialState);
            globalValues[activeStep] = initialState;
        }
    );

    return (
        <div className={classes.root}>
            <Typography className={classes.title}>Details</Typography>
            <div className={classes.row}>
                <InputLabel id="dataType-select-label" className={classes.label}>
                    TODO.
                </InputLabel>
            </div>
        </div>
    );
}

function getStepContent(step: number, setValues: any) {
    switch (step) {
        case 0:
            return <Details activeStep={step} setValues={setValues} />;
        default:
            return "Unknown step";
    }
}

function createRawData(done: () => void) {
    var dataType = globalValues[0].dataType;
    switch (dataType) {
        case `com.voxelfarm.program.view.blockmodel`: {
            break;
        }
        case `com.voxelfarm.program.view.pointcloud`: {
            break;
        }
        case `com.voxelfarm.program.view.density`: {
            break;
        }
        case `com.voxelfarm.program.view.mesh`: {
            break;
        }
        default: {
            break;
        }
    }
    done();
}

type IUploadData = {
    open: boolean;
    catalogId: string;
    handleClose: () => void;
};

export default function UploadDataPanel(props: IUploadData) {
    const { open } = props;

    const handleClose = () => {
        globalValues = [];
        props.handleClose();
    };

    const validateStep = (activeStep: number, values: any) => {
        switch (activeStep) {
            case 0: {
                if (values && values.name && values.name.length === 0) {
                    return false;
                }
                return true;
            }
            default:
                return true;
        }
    };

    const finalAction = () => {
        createRawData(() => {});
    };

    return (
        <div>
            <WizardPanel
                open={open}
                title={"Export"}
                steps={steps}
                getStepContent={getStepContent}
                handleClose={handleClose}
                validateStep={validateStep}
                finalAction={finalAction}
            />
        </div>
    );
}
